<template>
<div v-if="!isFooter">


<!-- <div class="wrap"> -->
    <table >

        <tbody @click="isAdult = !isAdult, isChild = !isChild, isInfant = !isInfant">
        <tr class="active">
            <td>
                <div> {{$t('perPaxPriceInfo.adult')}}</div>
            </td>
            <td>
                <div v-if="sSearchObj" class="wrapper">
                    <div> x {{sSearchObj.pax.adultCount }}</div>
                </div>
            </td>
            <td>
                <div class="currency">{{perPaxPriceObj.Currency}}</div>
            </td>
            <td>
                <div class="value">{{perPaxPriceObj.AdultPrice.Total.toString() | amountformat}}</div>
            </td>
        </tr>
        </tbody>
      
        <transition name="slide-fade">
            <!-- <CCollapse :show="isAdult"  :class="isAdult?'taxes-wrapper':'taxes-wrapper d-none'"> -->
            <tbody v-if="isAdult && !isCollapse" class="tax-table">
              <tr>
                <td>
                    <div class="taxes"> {{$t('perPaxPriceInfo.baseFare')}}</div>
                </td>
                <td></td>
                <td>
                    <div class="currency">{{perPaxPriceObj.Currency}}</div>
                </td>
                <td>
                    <div class="value">{{perPaxPriceObj.AdultPrice.BaseFare.toString() | amountformat}}</div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="taxes"> {{$t('perPaxPriceInfo.tax')}} </div>
                </td>
                <td></td>
                <td>
                    <div class="currency">{{perPaxPriceObj.Currency}}</div>
                </td>
                <td>
                    <div class="value">{{perPaxPriceObj.AdultPrice.Tax.toString() | amountformat}}</div>
                </td>
            </tr>
            
<!--            <tr>-->
<!--                <td>-->
<!--                    <div class="taxes"> {{$t('perPaxPriceInfo.total')}}</div>-->
<!--                </td>-->
<!--                <td></td>-->
<!--                <td>-->
<!--                    <div class="currency">{{perPaxPriceObj.Currency}}</div>-->
<!--                </td>-->
<!--                <td>-->
<!--                    <div class="value">{{perPaxPriceObj.AdultPrice.Total | amountformat}}</div>-->
<!--                </td>-->
<!--            </tr>-->
            </tbody>
        </transition>
        <!-- </CCollapse> -->
        <tbody v-if="sSearchObj&&sSearchObj.pax.childCount>0"  @click="isAdult = !isAdult, isChild = !isChild, isInfant = !isInfant" >
        <tr class="active">
            <td>
                <div> {{$t('perPaxPriceInfo.child')}}</div>
            </td>
            <td>
                <div class="wrapper">
                    <div> x {{sSearchObj.pax.childCount }}</div>
                </div>
            </td>
            <td>
                <div class="currency">{{perPaxPriceObj.Currency}}</div>
            </td>
            <td>
                <div class="value">{{perPaxPriceObj.ChildPrice.Total.toString() | amountformat}}</div>
            </td>
        </tr>
        </tbody>
        <transition name="slide-fade">
            <tbody class="tax-table" v-if="sSearchObj&&sSearchObj.pax.childCount>0 && isChild" >
            <tr>
                <td>
                    <div class="taxes"> {{$t('perPaxPriceInfo.baseFare')}}</div>
                </td>
                <td></td>
                <td>
                    <div class="currency">{{perPaxPriceObj.Currency}}</div>
                </td>
                <td>
                    <div class="value">{{perPaxPriceObj.ChildPrice.BaseFare.toString() | amountformat}}</div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="taxes"> {{$t('perPaxPriceInfo.tax')}} </div>
                </td>
                <td></td>
                <td>
                    <div class="currency">{{perPaxPriceObj.Currency}}</div>
                </td>
                <td>
                    <div class="value">{{perPaxPriceObj.ChildPrice.Tax.toString() | amountformat}}</div>
                </td>
            </tr>
            
<!--            <tr >-->
<!--                <td>-->
<!--                    <div class="taxes"> {{$t('perPaxPriceInfo.total')}}</div>-->
<!--                </td>-->
<!--                <td></td>-->
<!--                <td>-->
<!--                    <div class="currency">{{perPaxPriceObj.Currency}}</div>-->
<!--                </td>-->
<!--                <td>-->
<!--                    <div class="value">{{perPaxPriceObj.ChildPrice.Total | amountformat}}</div>-->
<!--                </td>-->
<!--            </tr>-->
            </tbody>
        </transition>
        <tbody v-if="sSearchObj&&sSearchObj.pax.infantCount>0"   @click="isAdult = !isAdult, isChild = !isChild, isInfant = !isInfant">
        <tr class="active">
            <td>
                <div> {{$t('perPaxPriceInfo.infant')}}</div>
            </td>
            <td>
                <div class="wrapper">
                    <div> x {{sSearchObj.pax.infantCount }}</div>
                </div>
            </td>
            <td>
                <div class="currency">{{perPaxPriceObj.Currency}}</div>
            </td>
            <td>
                <div class="value">{{perPaxPriceObj.InfantPrice.Total.toString() | amountformat}}</div>
            </td>
        </tr>
        </tbody>
        <transition name="slide-fade">
            <tbody v-if="sSearchObj&&sSearchObj.pax.infantCount>0 && isInfant" >
            <tr>
                <td>
                    <div class="taxes"> {{$t('perPaxPriceInfo.baseFare')}}</div>
                </td>
                <td></td>
                <td>
                    <div class="currency">{{perPaxPriceObj.Currency}}</div>
                </td>
                <td>
                    <div class="value">{{perPaxPriceObj.InfantPrice.BaseFare.toString() | amountformat}}</div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="taxes"> {{$t('perPaxPriceInfo.tax')}} </div>
                </td>
                <td></td>
                <td>
                    <div class="currency">{{perPaxPriceObj.Currency}}</div>
                </td>
                <td>
                    <div class="value">{{perPaxPriceObj.InfantPrice.Tax.toString() | amountformat}}</div>
                </td>
            </tr>
           
<!--            <tr >-->
<!--                <td>-->
<!--                    <div class="taxes"> {{$t('perPaxPriceInfo.total')}}</div>-->
<!--                </td>-->
<!--                <td></td>-->
<!--                <td>-->
<!--                    <div class="currency">{{perPaxPriceObj.Currency}}</div>-->
<!--                </td>-->
<!--                <td>-->
<!--                    <div class="value">{{perPaxPriceObj.InfantPrice.Total | amountformat}}</div>-->
<!--                </td>-->
<!--            </tr>-->
            </tbody>
        </transition>
        
    </table>
    <div class="paymentFeeTag" v-if="isPayment&&perPaxPriceObj.isPaymentFee&&perPaxPriceObj.PaymentAmount!=null">

 </div>
<table v-if="isPayment&& perPaxPriceObj.isPaymentFee&&perPaxPriceObj.PaymentAmount!=null">

     <tbody    >
     
        <tr >
            <td>
                <div> {{$t('totalpriceInfo.totalAmt')}}</div>
            </td>
            <td>
                <div class="wrapper">
                    <div> </div>
                </div>
            </td>
            <td>
                <div class="currency">{{perPaxPriceObj.Currency}}</div>
            </td>
            <td>
                <div class="value" v-if="perPaxPriceObj.hasOwnProperty('PaymentAmount')">{{perPaxPriceObj.TotalAmount-perPaxPriceObj.PaymentAmount | amountformat}}</div>
            </td>
        </tr>
      
        </tbody>
 <tbody v-if="isPayment" @click="isPaymentFee = !isPaymentFee"  >
     
        <tr >
            <td>
                <div> {{perPaxPriceObj.displayText?perPaxPriceObj.displayText:$t('perPaxPriceInfo.paymentFee')}}</div>
            </td>
            <td>
                <div class="wrapper">
                    <div> </div>
                </div>
            </td>
            <td>
                <div class="currency">{{perPaxPriceObj.Currency}}</div>
            </td>
            <td>
                <div class="value">{{perPaxPriceObj.PaymentAmount | amountformat}}</div>
            </td>
        </tr>
      
        </tbody>

<!--   
        <transition name="slide-fade">
            <tbody v-if="isPaymentFee" class="tax-table" >
          
            <tr>
                <td>
                    <div class="taxes"> {{$t('perPaxPriceInfo.baseFare')}}</div>
                </td>
                <td></td>
                <td>
                    <div class="currency">{{perPaxPriceObj.Currency}}</div>
                </td>
                <td>
                    <div class="value">{{perPaxPriceObj.PaymentBaseFare | amountformat}}</div>
                </td>
            </tr>
              <tr>
                <td>
                    <div class="taxes"> {{$t('perPaxPriceInfo.tax')}} </div>
                </td>
                <td></td>
                <td>
                    <div class="currency">{{perPaxPriceObj.Currency}}</div>
                </td>
                <td>
                    <div class="value">{{perPaxPriceObj.PaymentTax | amountformat}}</div>
                </td>
            </tr>

            </tbody>
           
        </transition> -->

        
         </table>
</div>



<div v-else class="card">
                                <div class="card-body">

                                    <div class="mt-2 sub-table-pass" style="">
                                        <div>
                                            
                                            <table v-if="perPaxPriceObj">
                                                <tbody class="city" v-if="selflightObj&&selflightObj.obFlight&&selflightObj.clientPricing&&!(isSingleCliPricing)">
                                                <tr>
                                                    <td>
                                                        <div class="d-flex" > <span>{{selflightObj.obFlight[0].flight.DepAirport}}</span> <span>-</span><Span>{{selflightObj.obFlight[selflightObj.obFlight.length-1].flight.ArrAirport}}</Span></div>
                                                    </td>
                                                    <td>
                                                    </td>
                                                    <td>
                                                        <div>{{selflightObj.clientPricing.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value"> {{selflightObj.clientPricing.TotalAmount.toString() | amountformat}}</div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                                 <tbody class="city" v-if="selflightObj&&selflightObj.ibFlight&&selflightObj.clientPricing">
                                                <tr>
                                                    <td>
                                                        <div class="d-flex" > <span>{{selflightObj.ibFlight[0].flight.DepAirport}}</span> <span>-</span><Span>{{selflightObj.ibFlight[selflightObj.ibFlight.length-1].flight.ArrAirport}}</Span></div>
                                                    </td>
                                                    <td>
                                                    </td>
                                                    <td>
                                                        <div>{{selflightObj.clientPricing.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <!-- <div v-if="Number(selflightObj.clientPricing.TotalAmount)==0" class="value"> {{selflightObj.clientPricing.TotalAmount }}</div> -->
                                                        
                                                        <div class="value"> {{selflightObj.clientPricing.TotalAmount.toString() | amountformat}}</div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                                <tbody class="passenger-det" v-if="sSearchObj.pax.adultCount>0" @click="isAdult=!isAdult" >

                                                <tr>
                                                    <td>
                                                        <div> {{$t('perPaxPriceInfo.adult')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper" >
                                                            <div> x {{sSearchObj.pax.adultCount }}</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.AdultPrice.Total.toString() | amountformat}}</div>
                                                    </td>
                                                </tr>


                                                </tbody>
                                                <transition name="slide-fade">
                                                <tbody class="tax-fare " v-if="isAdult">
                                                <tr>
                                                    <td>
                                                        <div>{{$t('perPaxPriceInfo.baseFare')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper">

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.AdultPrice.BaseFare.toString() | amountformat}}</div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <div> {{$t('perPaxPriceInfo.tax')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper">

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.AdultPrice.Tax.toString() | amountformat}}</div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                                </transition>
                                                <tbody class="passenger-det" v-if="sSearchObj&&sSearchObj.pax.childCount>0" @click="isAdult=!isAdult">

                                                <tr>
                                                    <td>
                                                        <div> {{$t('perPaxPriceInfo.child')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper">
                                                            <div> x {{sSearchObj.pax.childCount }}</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.ChildPrice.Total.toString() | amountformat}}</div>
                                                    </td>
                                                </tr>


                                                </tbody>
                                                <transition name="slide-fade">
                                                <tbody class="tax-fare" v-if=" isAdult&&sSearchObj&&sSearchObj.pax.childCount>0">
                                                <tr>
                                                    <td>
                                                        <div> {{$t('perPaxPriceInfo.baseFare')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper">

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.ChildPrice.BaseFare.toString() | amountformat}}</div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <div> {{$t('perPaxPriceInfo.tax')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper">

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.ChildPrice.Tax | amountformat}}</div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                                </transition>
                                                <tbody class="passenger-det" v-if="sSearchObj&&sSearchObj.pax.infantCount>0" @click="isAdult=!isAdult">

                                                <tr>
                                                    <td>
                                                        <div> {{$t('perPaxPriceInfo.infant')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper">
                                                            <div> x {{sSearchObj.pax.infantCount }}</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.InfantPrice.Total.toString() | amountformat}}</div>
                                                    </td>
                                                </tr>


                                                </tbody>
                                                <transition name="slide-fade">
                                                <tbody class="tax-fare" v-if="isAdult&&sSearchObj&&sSearchObj.pax.infantCount>0">
                                                <tr>
                                                    <td>
                                                        <div> {{$t('perPaxPriceInfo.baseFare')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper">

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.InfantPrice.BaseFare.toString() | amountformat}}</div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <div> {{$t('perPaxPriceInfo.tax')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper">

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.InfantPrice.Tax.toString() | amountformat}}</div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                                </transition>



                                            <!-- <tbody class="passenger-det" v-if="sSearchObj&&isPayment" @click="isAdult=!isAdult">

                                                <tr>
                                                    <td>
                                                        <div> {{$t('perPaxPriceInfo.paymentFee')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper">
                                                            <div> </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.PaymentAmount | amountformat}}</div>
                                                    </td>
                                                </tr>


                                            </tbody> -->
                                            <!-- <tbody class="tax-fare" v-if="isAdult&&sSearchObj&&isPayment">
                                                <tr>
                                                    <td>
                                                        <div> {{$t('perPaxPriceInfo.baseFare')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper">

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.PaymentBaseFare | amountformat}}</div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <div> {{$t('perPaxPriceInfo.tax')}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="wrapper">

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="currency">{{perPaxPriceObj.Currency}}</div>
                                                    </td>
                                                    <td>
                                                        <div class="value">{{perPaxPriceObj.PaymentTax | amountformat}}</div>
                                                    </td>
                                                </tr>
                                            </tbody>  -->


                                            </table>



                                            
                                        </div>

                                        
                                    </div>
                                </div>
                            </div>







<!-- <CCard>
    <CCardBody>
        
        <CRow @click="isAdult = !isAdult">
            <CCol>
                  {{$t('perPaxPriceInfo.adult')}}
            </CCol>
            <CCol>
                {{perPaxPriceObj.Currency}}
            </CCol>
            <CCol>
                {{sSearchObj.pax.adultCount }} * {{perPaxPriceObj.AdultPrice.Total}}
            </CCol>
        </CRow>
       <CCollapse  :show="isAdult" class="mt-2">
            <CCard body-wrapper>
              <CCol> 
                {{$t('perPaxPriceInfo.tax')}} {{perPaxPriceObj.AdultPrice.Tax}}
              </CCol>
              <CCol>
                {{$t('perPaxPriceInfo.baseFare')}} {{perPaxPriceObj.AdultPrice.BaseFare}}
              </CCol>
              <hr />
              <CCol>
              {{$t('perPaxPriceInfo.total')}} {{perPaxPriceObj.AdultPrice.Total}}
              </CCol>
            </CCard>
          </CCollapse>
         
          <CRow v-if="sSearchObj.pax.childCount>0" @click="isChild = !isChild">
            <CCol>
                {{$t('perPaxPriceInfo.child')}}
            </CCol>
            <CCol>
                {{perPaxPriceObj.Currency}}
            </CCol>
            <CCol>
                {{sSearchObj.pax.childCount }} * {{perPaxPriceObj.ChildPrice.Total}}
            </CCol>
        </CRow>
       <CCollapse v-if="sSearchObj.pax.childCount>0" :show="isChild" class="mt-2">
            <CCard body-wrapper>
              <CCol>
                {{$t('perPaxPriceInfo.tax')}} {{perPaxPriceObj.ChildPrice.Tax}}
              </CCol>
              <CCol>
                {{$t('perPaxPriceInfo.baseFare')}} {{perPaxPriceObj.ChildPrice.BaseFare}}
              </CCol>
              <hr />
              <CCol>
              {{$t('perPaxPriceInfo.total')}} {{perPaxPriceObj.ChildPrice.Total}}
              </CCol>
            </CCard>
          </CCollapse>
          
          <CRow v-if="sSearchObj.pax.infantCount>0" @click="isInfant = !isInfant">
            <CCol>
                 {{$t('perPaxPriceInfo.infant')}}
            </CCol>
            <CCol>
                {{perPaxPriceObj.Currency}}
            </CCol>
            <CCol>
                {{sSearchObj.pax.infantCount }} * {{perPaxPriceObj.InfantPrice.Total}}
            </CCol>
        </CRow>
       <CCollapse v-if="sSearchObj.pax.infantCount>0" :show="isInfant" class="mt-2">
            <CCard body-wrapper>
              <CCol>
                {{$t('perPaxPriceInfo.tax')}}  {{perPaxPriceObj.InfantPrice.Tax}}
              </CCol>
              <CCol>
                {{$t('perPaxPriceInfo.baseFare')}} {{perPaxPriceObj.InfantPrice.BaseFare}}
              </CCol>
              <hr />
              <CCol>
              {{$t('perPaxPriceInfo.total')}} {{perPaxPriceObj.InfantPrice.Total}}
              </CCol>
            </CCard>
          </CCollapse>
          <CRow>
              <CCol>
                  {{$t('perPaxPriceInfo.fare')}}
              </CCol>
              <CCol>
                  {{perPaxPriceObj.Currency}}
              </CCol>
              <CCol>
                  {{perPaxPriceObj.TotalBaseFare}}
              </CCol>
          </CRow>
          <CRow>
              <CCol>
                  {{$t('perPaxPriceInfo.taxFees')}}
              </CCol>
              <CCol>
                  {{perPaxPriceObj.Currency}}
              </CCol>
              <CCol>
                  {{perPaxPriceObj.TotalTax}}
              </CCol>
          </CRow>
          <hr />
          <CRow>
              <CCol>
                  {{$t('perPaxPriceInfo.total')}}
              </CCol>
              <CCol>
                  {{perPaxPriceObj.Currency}}
              </CCol>
              <CCol>
                  {{perPaxPriceObj.TotalAmount}}
              </CCol>
          </CRow>
    </CCardBody>
</CCard> -->
<!-- </div> -->


</template>
<script>

import { TRIP, PAX, PAX_COUNT } from "../../util/constants.js";
import Logger from "../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router ,{navigate,goBack }from "../../router/index";

import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME } from "../../util/constants";
import BaseConfiguration from "../../config/base.js";
import SERVICE_URL from "../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";

export default {
  name: COMPONENT_NAME.C_PERPAXPRICE,
  components: {
    
  },
   props://['selflightObj'],
       {
         selflightObj:{
            type:Object,
              default: null
        },
        isPayment:{
               type:Boolean,
              default: false
        },
        
        isFooter:{
         type:Boolean,
            default: null
       },
       isCollapse:{
         type:Boolean,
            default: null
       },
       isSingleCliPricing:{
            type:Boolean,
            default: false
       }
        
       },
   
  data: () => ({
    isPaymentFee:false,
      isAdult: false,
      isChild: false,
      isInfant: false,
     perPaxPriceObj:null
  }),
  watch: {    
      selflightObj:{
        immediate: false, 
        deep: true,
    handler: function (newVal, oldVal) {
      
      if(oldVal==newVal||oldVal!=newVal){
      //   if(this.isCollapse==true)
      // { this.isAdult= false,
      // this.isChild= false,
      // this.isInfant= false}
        this.perPaxPriceObj = this.getFormattedTotal(this.sSearchObj,this.selflightObj);
    }
        
      }
      },
      
      
      },
  
  created(){
    
    this.perPaxPriceObj = this.getFormattedTotal(this.sSearchObj,this.selflightObj);
    
  },
  methods:{
    
    


    //to get total fare for one way , round trip

    getFormattedTotal(pSearchObj, pFlightInfodata) {
      
      let retValue = {
        AdultPrice: null,
        ChildPrice: null,
        InfantPrice: null,
        TotalTax: 0,
        TotalBaseFare: 0,
        TotalAmount: 0,
        Currency: 0,
        PaymentAmount:0,
        PaymentBaseFare:0,
        PaymentTax:0,
        displayText:null,
        isPaymentFee:false
      };

      try {
    //    if(this.isFooter){
    //       this.isAdult= true,
    //   this.isChild= true,
    //   this.isInfant=true

    //    }
       if (pFlightInfodata.ib && pFlightInfodata.ib.clientPricing && pFlightInfodata.ob && 
       pFlightInfodata.ob.clientPricing) {
           if(pFlightInfodata.ob.clientPricing.hasOwnProperty('isPaymentFee')&&pFlightInfodata.ob.clientPricing.isPaymentFee){
               retValue.PaymentAmount=pFlightInfodata.ob.clientPricing.PaymentAmount;
                retValue.PaymentBaseFare=pFlightInfodata.ob.clientPricing.PaymentBaseFare;
              retValue.PaymentTax=pFlightInfodata.ob.clientPricing.PaymentTax;
             retValue.displayText=pFlightInfodata.ob.clientPricing.displayText;
        retValue.isPaymentFee=pFlightInfodata.ob.clientPricing.isPaymentFee;


           }

          if (pSearchObj.pax.adultCount > 0) {
            retValue.AdultPrice = this.paxPricing(
              pFlightInfodata,
              "AdultPrice"
            );
          }

          if (pSearchObj.pax.childCount > 0) {
            retValue.ChildPrice = this.paxPricing(
              pFlightInfodata,
              "ChildPrice"
            );
          }

          if (pSearchObj.pax.infantCount > 0) {
            retValue.InfantPrice = this.paxPricing(
              pFlightInfodata,
              "InfantPrice"
            );
          }
          retValue.TotalTax = this.getFinalTotal(pFlightInfodata).TotalTax;
          retValue.TotalBaseFare = this.getFinalTotal(
            pFlightInfodata
          ).TotalBaseFare;
          retValue.TotalAmount = this.getFinalTotal(
            pFlightInfodata
          ).TotalAmount;
          retValue.Currency = this.getFinalTotal(pFlightInfodata).Currency;
          // retValue.total= this.getFinalTotal(pFlightInfodata);
          // alert(JSON.stringify(total));
        }
        else if (pFlightInfodata.ob != null ) {
          retValue = pFlightInfodata.ob.clientPricing;
        }else if (pFlightInfodata.obFlight ) {
          retValue = pFlightInfodata.clientPricing;
        } else if (pFlightInfodata.ib != null) {
          retValue = pFlightInfodata.ib.clientPricing;
        } 
         else if (pFlightInfodata.ibFlight) {
          retValue = pFlightInfodata.clientPricing;
        } 
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.FLIGHTRESULTS,
          "error in getFormattedTotal",
          err.toString(),
          "getFormattedTotal",
          LOG_TYPE.ERROR
        );
      }

      return retValue;
    },

    // total calculation of both ob and ib

    getFinalTotal(pFlightInfodata) {
      let retValue = {
        TotalTax: 0,
        TotalBaseFare: 0,
        TotalAmount: 0,
        Currency: 0
      };
      try {
        retValue.TotalTax =
          pFlightInfodata.ob.clientPricing.TotalTax +
          pFlightInfodata.ib.clientPricing.TotalTax;
        retValue.TotalBaseFare =
          pFlightInfodata.ob.clientPricing.TotalBaseFare +
          pFlightInfodata.ib.clientPricing.TotalBaseFare;
        retValue.TotalAmount =
          pFlightInfodata.ob.clientPricing.TotalAmount +
          pFlightInfodata.ib.clientPricing.TotalAmount;
        retValue.Currency = pFlightInfodata.ob.clientPricing.Currency;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.FLIGHTRESULTS,
          "error in getFinalTotal",
          err.toString(),
          "getFinalTotal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    //total tax calculation for all types of pax

    paxPricing(pFlightInfodata, pPaxPrice) {
      let retValue = {
        Tax: null,
        BaseFare: null,
        Total: null
      };
      try {
        if (pPaxPrice) {
          // console.log(JSON.stringify(Object.keys(pFlightInfodata.ob.clientPricing).length));
          for (let i = 0;i < Object.keys(pFlightInfodata.ob.clientPricing).length;i++) {
            
            if (Object.keys(pFlightInfodata.ob.clientPricing)[i] == pPaxPrice) {
              for (let j = 0;j < Object.keys(pFlightInfodata.ib.clientPricing).length;j++) {
                if ( Object.keys(pFlightInfodata.ib.clientPricing)[j] == pPaxPrice) {
                  retValue.Tax =Math.round((Object.values(pFlightInfodata.ob.clientPricing)[i].Tax +
                        Object.values(pFlightInfodata.ib.clientPricing)[j].Tax) * 1e12) / 1e12;
                  retValue.BaseFare =((Object.values(pFlightInfodata.ob.clientPricing)[i].BaseFare +
                      Object.values(pFlightInfodata.ib.clientPricing)[j].BaseFare) *1e12) / 1e12;
                  retValue.Total =Math.round((Object.values(pFlightInfodata.ob.clientPricing)[i].Total +
                        Object.values(pFlightInfodata.ib.clientPricing)[j].Total) *1e12) / 1e12;
                  break; // j=0;
                }
              }
            }
          }
          
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.FLIGHTRESULTS,
          "error in paxPricing",
          err.toString(),
          "paxPricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

  },
  
  computed: {
    ...mapGetters("sCSearch", {
          sSearchObj: "GET_SEARCH_OBJ",      
        }),
    
  },
}
</script>
<style>
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }
.paymentFeeTag{
    min-height: 60px;
    width: calc(100% - 40px);
    border-top: dashed 2px #d7d9dd;
    position: absolute;
    top: 133px;
    /*bottom: 65px;*/
}
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
    0%{
        transform: translate(0px, -10px);
        /*opacity: 0;*/
    }

100%{
    transform: translate(0px, 0px);
    /*opacity: 1;*/
}

/*  0% {*/
/*    transform: scale(0);*/
/*  }*/
/*  50% {*/
/*    transform: scale(1.1);*/
/*  }*/
/*  100% {*/
/*    transform: scale(1);*/
/*  }*/
}
</style>